( function () {
	'use strict';

	var initializedSplides = new WeakSet();

	function initFeaturedProjects( section ) {
		const splideEl = section.querySelector( '.featured-projects__splide' );
		const prevBtn  = section.querySelector( '.featured-projects__arrow--prev' );
		const nextBtn  = section.querySelector( '.featured-projects__arrow--next' );

		if ( ! splideEl || typeof window.Splide === 'undefined' ) return;
		if ( initializedSplides.has( splideEl ) ) return;
		initializedSplides.add( splideEl );

		const splide = new window.Splide( splideEl, {
			type:        'slide',
			perPage:     3,
			perMove:     1,
			gap:         '72px',
			arrows:      false,
			pagination:  false,
			rewind:      false,
			drag:        true,
			snap:        true,
			mediaQuery:  'max',
			breakpoints: {
				1023: { perPage: 2, gap: '32px' },
				599:  { perPage: 1, gap: '24px' },
			},
		} );

		if ( prevBtn ) prevBtn.addEventListener( 'click', () => splide.go( '<' ) );
		if ( nextBtn ) nextBtn.addEventListener( 'click', () => splide.go( '>' ) );

		splide.on( 'mounted move', function () {
			if ( ! prevBtn || ! nextBtn ) return;
			const index    = splide.index;
			const lastPage = splide.Components.Controller.getEnd();
			prevBtn.disabled = index === 0;
			nextBtn.disabled = index === lastPage;
		} );

		splide.mount();
	}

	function boot() {
		document.querySelectorAll( '.featured-projects' ).forEach( initFeaturedProjects );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', boot );
	} else {
		boot();
	}

	if ( typeof wp !== 'undefined' && wp.domReady ) {
		wp.domReady( function () {
			boot();

			const observer = new MutationObserver( function ( mutations ) {
				mutations.forEach( function ( mutation ) {
					mutation.addedNodes.forEach( function ( node ) {
						if ( ! ( node instanceof HTMLElement ) ) return;
						if ( node.closest( '.splide__pagination' ) ) return;
						if ( node.closest( '.splide__arrows' ) ) return;

						const sections = node.classList.contains( 'featured-projects' )
							? [ node ]
							: Array.from( node.querySelectorAll( '.featured-projects' ) );

						sections.forEach( initFeaturedProjects );
					} );
				} );
			} );

			observer.observe( document.body, { childList: true, subtree: true } );
		} );
	}

}() );